// extracted by mini-css-extract-plugin
export default {"circle":"Check_circle_Ix6wL","step":"Check_step_J3Afk","divCheck":"Check_divCheck_csYMw","check":"Check_check_y4eSr","active":"Check_active_tbnFR","inactive":"Check_inactive_w1uGR"};